// Libs
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import reportWebVitals from './reportWebVitals';
// Components
import App from '~/App';
import { GlobalStyles } from '~/components/common';
// Context
import { LoadingProvider } from '~/contexts/LoadingContext';
// Shares
import 'antd/dist/reset.css';
import store from '~/redux/store';
import './utils/i18n';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyles>
        <LoadingProvider>
          <App />
        </LoadingProvider>
      </GlobalStyles>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

reportWebVitals();
